import { connect } from 'react-redux';

import NotFoundPageExploreMore from 'components/NotFoundPageExploreMore';
import ACTIONS from 'state/constants';
import GENERIC_CTA_CLICKED_EVENT from 'utils/Rudderstack/constants';

import { DATA } from './constants';

const mapStateToProps = () => {
  return {
    cards: DATA,
  };
};

const mapDispatchToProps = dispatch => ({
  trackClick: ({ name, url }) => {
    dispatch({
      type: ACTIONS.TRACK_CTA_CLICK_EVENT,
      payload: {
        type: GENERIC_CTA_CLICKED_EVENT.TYPES.CARD,
        location: GENERIC_CTA_CLICKED_EVENT.LOCATIONS.NOT_FOUND_CATEGORY_ENTRY,
        name,
        url,
      },
    });

    return true;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NotFoundPageExploreMore);
